// mega menu slider ---
jQuery(document).ready(function() { 
        $(".slider-nav").owlCarousel({       
          // Most important owl features
          items : 5,
          itemsDesktop : [1199,4],
          itemsDesktopSmall : [980,3],
          itemsTablet: [768,2],
          itemsTabletSmall: false,
          itemsMobile : [479,1],
          singleItem : false,
       
          //Basic Speeds
          slideSpeed : 200,
          paginationSpeed : 800,
          rewindSpeed : 1000,
       
          //Autoplay
          autoPlay : true,
          
       
          // Navigation
          navigation : true,
          navigationText : [" < "," > "],
          rewindNav : true,
          scrollPerPage : false,
          
          //Pagination
          pagination : false,
          paginationNumbers: false,
       
          // Responsive 
          responsive: true,
          responsiveRefreshRate : 200,
          responsiveBaseWidth: window,
       
          // CSS Styles
          baseClass : "owl-carousel",
          theme : "owl-theme",
       
          //Lazy load
          lazyLoad : false,
          lazyFollow : true,
       
          //Auto height
          autoHeight : false,
       
          //JSON 
          jsonPath : false, 
          jsonSuccess : false,
       
          //Mouse Events
          mouseDrag : false,
          touchDrag : false,
       
          //Transitions
          transitionStyle : false,
       
          // Other
          addClassActive : false,
       
          //Callbacks
          beforeInit: false, 
          afterInit: false, 
          beforeMove: false, 
          afterMove: false,
          afterAction: false,
          startDragging : false
       
      })       
      }); 